module.exports = "<div class=selectBox> <img class=arrowDown src=" + require("../../img/headerIcons/arrow-blue.svg") + "> <span></span> <div class=options> <div ng-repeat=\"item in list\" data-value={{::options.value(item)}} alt={{::options.caption(item)}} title={{::options.caption(item)}}>{{::options.caption(item)}}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./public/views/modals/dropdown.html
// module id = 102
// module chunks = 0